import { EntypoSocialLinkedinWithCircle, IcBaselineFacebook, MdiGithub, SimpleIconsGmail } from "@/components/icons";
import { ContactType } from "@/types/data";

export const contactList: ContactType[] = [
    {
        id: 1,
        href: "https://www.facebook.com/isongwut.me/",
        icon: <IcBaselineFacebook width={24} height={24} />,
    },
    {
        id: 2,
        href: "https://www.github.com/1ces",
        icon: <MdiGithub width={24} height={24} />,
    },
    {
        id: 3,
        href: "https://www.linkedin.com/in/songwut-malisri-7aab99225/",
        icon: <EntypoSocialLinkedinWithCircle width={24} height={24} />,
    },
    {
        id: 4,
        href: "mailto:songwut.malisri@gmail.com",
        icon: <SimpleIconsGmail width={24} height={24} />,
    }
]
